import React from 'react';
import { DEFAULT_DIVIDER_CONTENT, normalizeDividerContent } from '../../utils/lectureNormalization';

const DividerRenderer = ({ block }) => {
    const baseContent = block?.content;
    const safeContent = normalizeDividerContent(baseContent);
    const isObjectContent = baseContent !== null && typeof baseContent === 'object' && !Array.isArray(baseContent);

    if (process.env.NODE_ENV !== 'production' && !isObjectContent) {
        console.warn('[DividerRenderer] divider content is not an object; repaired for rendering', { block });
    }

    const { style, thickness, color, spacing, width } = { ...DEFAULT_DIVIDER_CONTENT, ...safeContent };

    const spacingClasses = {
        small: 'my-4',
        medium: 'my-8',
        large: 'my-12'
    };

    const widthClasses = {
        quarter: 'w-1/4',
        half: 'w-1/2',
        'three-quarters': 'w-3/4',
        full: 'w-full'
    };

    const dividerStyle = {
        borderTop: `${thickness}px ${style} ${color}`,
        margin: '0 auto'
    };

    return (
        <div className={`${spacingClasses[spacing]} flex justify-center`} aria-hidden="true">
            <hr
                className={`${widthClasses[width]} border-0`}
                style={dividerStyle}
            />
        </div>
    );
};

export default DividerRenderer;
